import React from "react";
import { View, TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";
import AppTheme from "../../AppTheme";

export default function Snooze(props) {
  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M5.25325 2.25997L4.39992 1.23997L1.33325 3.80663L2.19325 4.82663L5.25325 2.25997ZM14.6666 3.8133L11.5999 1.23997L10.7399 2.25997L13.8066 4.8333L14.6666 3.8133ZM7.99992 2.66663C4.68659 2.66663 1.99992 5.3533 1.99992 8.66663C1.99992 11.98 4.67992 14.6666 7.99992 14.6666C11.3133 14.6666 13.9999 11.98 13.9999 8.66663C13.9999 5.3533 11.3133 2.66663 7.99992 2.66663ZM7.99992 13.3333C5.41992 13.3333 3.33325 11.2466 3.33325 8.66663C3.33325 6.08663 5.41992 3.99997 7.99992 3.99997C10.5799 3.99997 12.6666 6.08663 12.6666 8.66663C12.6666 11.2466 10.5799 13.3333 7.99992 13.3333ZM5.99992 7.3333H8.41992L5.99992 10.1333V11.3333H9.99992V9.99997H7.57992L9.99992 7.19997V5.99997H5.99992V7.3333Z"
          fill={AppTheme.almostBlack}
        />
      </Svg>
    </TouchableOpacity>
  );
}
